import { createAction } from 'redux-actions'
import * as types from './actionTypes'
import { IS_APPLICATION_LOADING, SHOW_USER_FEEDBACK } from '../../actions/types'
import { FIND_DRIVER_BY_CPF, FIND_DRIVER_BY_NAME_NOT_FOUND } from '../LoadsDetails/actionTypes'
import DriverServices from './service'
import FileService from '../../services/FileService'
import FILE_TYPES from '../../utils/fileEnums'
import history from '../../history'


export const postNewDriver = (payload, selectDriver) => (
  (dispatch) => {
    DriverServices
      .postNewDriver(payload)
      .then((result) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        dispatch(createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Motorista cadastrado.',
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }))
        if (selectDriver) {
          return dispatch(createAction(FIND_DRIVER_BY_CPF)(result))
        }
        if (result && result.id) {
          history.push('/drivers')
        }
        return null
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)

export const updateDriverInfo = (payload) => (
  (dispatch) => {
    DriverServices
      .update(payload.id, payload)
      .then((result) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        dispatch(createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Motorista atualizado.',
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }))
        if (result && result.id) {
          history.push('/drivers')
        }
        return null
      })
      .catch((err) => {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)

export const saveDriverDocument = (payload, type, selectDriver) => (
  (dispatch) => {
    if (payload.cnhImage) {
      return FileService
        .upload(payload.cnhImage, FILE_TYPES.driver.document)
        .then((result) => {
          if (!result) {
            console.log('Erro ao salvar a CNH do usuário')
            return null
          }
          const newPayload = { ...payload, cnhImage: result }
          if (type === 'CREATE') {
            return dispatch(postNewDriver(newPayload, selectDriver))
          }
          return null
        })
    }
    if (type === 'CREATE') {
      return dispatch(postNewDriver(payload, selectDriver))
    }
    return null
  }
)

export const saveDriverPhoto = (payload, type, selectDriver) => (
  (dispatch) => {
    if (payload.profileImage) {
      return FileService
        .upload(payload.profileImage, FILE_TYPES.driver.avatar)
        .then((result) => {
          if (!result) {
            console.log('Erro ao salvar a foto do usuário')
            return null
          }
          const newPayload = { ...payload, profileImage: result }
          return dispatch(saveDriverDocument(newPayload, type, selectDriver))
        })
    }
    return dispatch(saveDriverDocument(payload, type, selectDriver))
  }
)

export const saveNewDriver = (params, selectDriver) => (
  (dispatch) => {
    let { cnhExpeditionDate, cnhValidDate } = params

    if (!cnhExpeditionDate) cnhExpeditionDate = null
    if (!cnhValidDate) cnhValidDate = null

    const payload = {
      ...params,
      cnhExpeditionDate,
      cnhValidDate,
    }
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    dispatch(saveDriverPhoto(payload, 'CREATE', selectDriver))
  }
)

export const updateDriver = payload => (
  dispatch => (
    dispatch(saveDriverPhoto(payload, 'UPDATE'))
  )
)

export const getInfo = () => (
  (dispatch) => {
    DriverServices
      .getInfo()
      .then((result) => {
        dispatch(createAction(types.FETCH_DRIVER_INFORMATION)(result))
      })
      .catch((err) => {
        console.log(err)
      })
  }
)

export const setDriverNotFound = () => (
  (dispatch) => {
    dispatch(createAction(IS_APPLICATION_LOADING)(false))
    dispatch(createAction(FIND_DRIVER_BY_NAME_NOT_FOUND)())
  }
)
